var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "12.37 13.7 23.41 21.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2684FF",
    fillRule: "evenodd",
    d: "M12.547 13.958a.75.75 0 0 1 .578-.26l21.889.003a.75.75 0 0 1 .75.87L32.58 34.116a.75.75 0 0 1-.75.63H16.556a1.02 1.02 0 0 1-.997-.851l-3.184-19.328a.75.75 0 0 1 .172-.61Zm9.11 13.708h4.874l1.181-6.896h-7.376l1.32 6.896Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#bitbucket_svg__a)",
    d: "M34.751 20.77h-7.038l-1.182 6.896h-4.875L15.9 34.5c.182.157.415.245.656.247h15.278a.75.75 0 0 0 .75-.63z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bitbucket_svg__a",
    x1: 30.256,
    x2: 22.125,
    y1: 18.389,
    y2: 29.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0052CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2684FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.d212db4e36c091839b0a6c8cb18148eb.svg";
export { ForwardRef as ReactComponent };